import { enc } from './core.js';
export function statsApi(c) {
    const base = (localId) => `/locals/${enc(localId)}/stats`;
    return {
        overview: (localId, query = {}) => c.get(`${base(localId)}/overview`, { query: query }),
        salesSeries: (localId, query = {}) => c.get(`${base(localId)}/sales-series`, { query: query }),
        topItems: (localId, query = {}) => c.get(`${base(localId)}/top-items`, { query: query }),
        paymentMethods: (localId, query = {}) => c.get(`${base(localId)}/payment-methods`, { query: query }),
        expensesVsIncome: (localId, query = {}) => c.get(`${base(localId)}/expenses-vs-income`, { query: query }),
        margin: (localId, query = {}) => c.get(`${base(localId)}/margin`, { query: query }),
    };
}
//# sourceMappingURL=stats.js.map